"use client";

import { AiMasteringProvider } from "@/components/pages/ai-mastering/providers/ai-mastering-provider";
import AiMasteringPage from "@/components/pages/ai-mastering/ai-mastering-page";
import MasteringProgressProvider from "@/components/pages/ai-mastering/hooks/mastering-progress-provider";

const AiMastering = () => {
  return (
    <MasteringProgressProvider>
      <AiMasteringProvider>
        <AiMasteringPage />
      </AiMasteringProvider>
    </MasteringProgressProvider>
  );
};

export default AiMastering;
